import { DialogTitle as DialogTitleCore } from '@material-ui/core';
import * as lib from '~/dependencies';
import { colors } from '~/layout';

export const Title = lib.styled(DialogTitleCore)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  
  &.MuiDialogTitle-root {
    padding: 20px 15px 9px;
  }

  span {
    font-size: 18px;
    font-weight: 500;
  }
`;

export const SubmitButton = lib.styled.button`
  display: flex;
  width: 85px;
  height: 26px;
  justify-content: center;
  align-items: center;
  align-self: flex-end;
  font-size: 14px;
  font-weight: 800;
  font-family: Nunito!important;
  color: #FFF;
  border-width: 0px;
  border-radius: 50px;
  cursor: pointer;
  background: linear-gradient(50.28deg,#67C2E4 2.79%,#0C4BBC 73.37%);
  margin: 15px -9px 7px 0;
  &:focus {
    outline: 0;
  }

  .loader {
    color: ${colors.white}
  }
`;
